
export const isUniqueArray = (values) => {
  const uniqueValues = Array.from(new Set(values))
  return values.length == uniqueValues.length
}

export const uniq = function uniq(array) {
  return array.filter((elem, index, self) => self.indexOf(elem) === index);
}

export const mergeUnique = (arr1, arr2, key1?, key2?, isStr?) => {
  return arr2.concat(arr1.filter((item) => {
    if (isStr) {
      return arr2.findIndex((_item) => _item == item) === -1;
    }
    return arr2.findIndex((_item) => _item[key2 || 'id'] == item[key1 || 'id']) === -1;
  }));
}

export const removeItems = (arr1, arr2, key1?, key2?) => {
  return arr1.filter((item) => {
    return !arr2.find((_item) => _item[key2 || 'id'] == item[key1 || 'id'])
  });
}

export const groupBy = (array, getKey) => {
  return array?.reduce((obj, cur, idx, src) => {
    const key = getKey(cur, idx, src);
    (obj[key] || (obj[key] = [])).push(cur);
    return obj;
  }, {});
}

export const sliceByNumber = (array, number) => {
  const length = Math.ceil(array.length / number)
  return new Array(length).fill(0).map((_, i) => {
    return array.slice(i * number, (i + 1) * number)
  })
}